var _use, _use2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientConnectUsageRegistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "matrix(.77682 0 0 .77682 6.5 6.822)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "matrix(.77682 0 0 .77682 21.625 17.308)",
    width: "100%",
    height: "100%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.77682 0 0 .77682 -3773.498 -383.732)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(4881.49 512.255)",
    width: "100%",
    height: "100%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_stroke_2x",
    transform: "translate(4881.49 512.255)",
    width: "100%",
    height: "100%"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M12.477 10.987c1.641 0 3.507-1.69 3.507-4.494C15.984 3.69 14.118 2 12.477 2S8.97 3.69 8.97 6.493c0 2.803 1.866 4.494 3.507 4.494zm0 2c3.042 0 5.507-2.908 5.507-6.494S15.52 0 12.477 0C9.436 0 6.97 2.907 6.97 6.493c0 3.586 2.466 6.494 5.507 6.494zm1.922 4.1H3a1 1 0 0 0-1 1v5.9h15.124a9.1 9.1 0 0 0 3.12 2H0v-7.9a3 3 0 0 1 3-3h11.71a9.09 9.09 0 0 0-.311 2z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M4.572 0H3.429v3.451H0v1.185h3.429v3.362h1.143V4.636H8V3.451H4.572z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_stroke_2x",
    d: "M14 8a6 6 0 0 1-6 6v4c5.523 0 10-4.477 10-10zm-6 6a6 6 0 0 1-6-6h-4c0 5.523 4.477 10 10 10zM2 8a6 6 0 0 1 6-6v-4C2.477-2-2 2.477-2 8zm6-6a6 6 0 0 1 6 6h4C18 2.477 13.523-2 8-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientConnectUsageRegistration);
export default __webpack_public_path__ + "static/media/ClientConnectUsage_registration.9e4f11a8ae6318eaf7df658601c61ae7.svg";
export { ForwardRef as ReactComponent };